import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <Box sx={sxProps.container}>
      <Typography variant="h1" sx={sxProps.header}>
        {t("notFound.title")}
      </Typography>
      <Typography variant="h5" sx={sxProps.subheader}>
        {t("notFound.heading")}
      </Typography>
      <Typography variant="body1" sx={sxProps.body}>
        {t("notFound.message")}
      </Typography>
      <Button variant="contained" color="primary" onClick={handleGoHome}>
        {t("notFound.goHome")}
      </Button>
    </Box>
  );
};

export default NotFoundPage;

const sxProps = {
  container: {
    height: "calc(100vh - 85px)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    bgcolor: "#f7f7f7",
    p: 3,
  },
  header: {
    fontSize: "6rem",
    fontWeight: "bold",
    color: "primary.main",
  },
  subheader: {
    fontSize: "2rem",
    mb: 2,
  },
  body: {
    fontSize: "1.2rem",
    mb: 4,
  },
};
